import { GridComponent, ELoadingStatus } from './components/grid.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid';

import { 
  Component, 
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  Output,
  SimpleChanges,
  EventEmitter,
  TemplateRef,
  ViewChild,
  NgZone,
  Inject,
  forwardRef
} from '@angular/core';

import { isEqual, isNil, isEmpty, set } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil, mergeMap, shareReplay } from 'rxjs/operators';
import { BaseComponent } from './components/base.component';
import { SharedModule } from './shared.module';import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DatexFormControl, validateControlOnChange, validateFormOnControlChange } from './models/datex-form-control';
import { Styles, ControlContainerStyles } from './models/style';
import { FieldModel } from './models/field';
import { FieldsetModel } from './models/fieldset';
import { ToolModel } from './models/tool';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles,
  ValueControlModel
} from './models/control';
import { datCodeValidator } from './components/code-validator.directive';import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { ProgrammableLogicController_ShellService } from './ProgrammableLogicController.shell.service';
import { ProgrammableLogicController_OperationService } from './ProgrammableLogicController.operation.service';
import { ProgrammableLogicController_DatasourceService } from './ProgrammableLogicController.datasource.index';
import { ProgrammableLogicController_FlowService } from './ProgrammableLogicController.flow.index';
import { ProgrammableLogicController_FrontendFlowService } from './ProgrammableLogicController.frontend.flow.service';
import { ProgrammableLogicController_ReportService } from './ProgrammableLogicController.report.index';
import { ProgrammableLogicController_LocalizationService } from './ProgrammableLogicController.localization.service';
import { ProgrammableLogicController_connector_mappings_grid_ComponentContextService } from './ProgrammableLogicController.connector_mappings_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './ProgrammableLogicController.frontend.types'
import { $frontendTypes as $types} from './ProgrammableLogicController.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';
import { ProgrammableLogicController_warehouses_dd_singleComponent } from './ProgrammableLogicController.warehouses_dd_single.component'
import { ProgrammableLogicController_connectors_dd_singleComponent } from './ProgrammableLogicController.connectors_dd_single.component'
import { ProgrammableLogicController_location_zone_dd_singleComponent } from './ProgrammableLogicController.location_zone_dd_single.component'


interface IProgrammableLogicController_connector_mappings_gridComponentEntity {
  connector_name?: string, footprint_zone?: string, connector_zone?: string, connector_id?: string, warehouse_name?: string, warehouse_id?: number}



class ProgrammableLogicController_connector_mappings_gridComponentRowModel extends GridRowModel {
  grid: ProgrammableLogicController_connector_mappings_gridComponent;
  entity: IProgrammableLogicController_connector_mappings_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
    warehouse_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    connector_name_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    connector_zone_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    footprint_zone_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
  });

  override cells = {
    warehouse: null,
    connector_name: null,
    connector_zone: null,
    footprint_zone: null,
    connector_id: null,
  }

  get $fields_footprint_zone_selector_inParams_warehouseId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = $row.cells.warehouse.editControl.value;
    
    return expr;
  }


  constructor(
    grid: ProgrammableLogicController_connector_mappings_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: ProgrammableLogicController_ShellService,
private $datasources: ProgrammableLogicController_DatasourceService,
private $flows: ProgrammableLogicController_FlowService,
private $frontendFlows: ProgrammableLogicController_FrontendFlowService,
private $reports: ProgrammableLogicController_ReportService,
private $localization: ProgrammableLogicController_LocalizationService,
private $operations: ProgrammableLogicController_OperationService,
private $logger: CleanupLoggerService,
private $context: ProgrammableLogicController_connector_mappings_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.warehouse = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.warehouse,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['warehouse_edit'] as DatexFormControl, 
        ESelectBoxType.dropdown, null,
        false,
        false,
        '', null)
      );
    
    this.cells.connector_name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.connector_name,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['connector_name_edit'] as DatexFormControl, 
        ESelectBoxType.dropdown, null,
        false,
        false,
        '', null)
      );
    
    this.cells.connector_zone = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.connector_zone,
      new TextModel(null, null, null, null, null)
,
      new TextBoxModel(this.formGroup.controls['connector_zone_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    this.cells.footprint_zone = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.footprint_zone,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['footprint_zone_edit'] as DatexFormControl, 
        ESelectBoxType.dropdown, null,
        false,
        false,
        '', null)
      );
    
    this.cells.connector_id = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.connector_id,
      new TextModel(null, null, null, null, null)
,
      new TextModel(null, null, null, null, null)
      );
    
    
    this.formGroup
      .controls['connector_name_edit']
      .valueChanges
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_connector_changed();
      });
  }

  async $initializeExisting(entity: IProgrammableLogicController_connector_mappings_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.footprint_zone,this.entity.connector_zone,this.entity.connector_id].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IProgrammableLogicController_connector_mappings_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.footprint_zone,this.entity.connector_zone,this.entity.connector_id].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = {};
    set($resultKey, 'footprint_zone',this.entity.footprint_zone);
    set($resultKey, 'connector_zone',this.entity.connector_zone);
    set($resultKey, 'connector_id',this.entity.connector_id);
    const $inParams: { fullTextSearch?: string, $keys: { footprint_zone?: string, connector_zone?: string, connector_id?: string }[] } = {
      $keys:[$resultKey],
      fullTextSearch:  $grid.fullTextSearch ,
    };
    const $data = await this.$datasources.ProgrammableLogicController.ds_connector_mappings_grid.getByKeys($inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns($inParams, $data);
      
    this.entity = $data.result[0] as IProgrammableLogicController_connector_mappings_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.warehouse.displayControl as TextModel).text = $row.entity.warehouse_name;
    (this.cells.warehouse.editControl as SelectBoxModel).reset($row.entity.warehouse_id);
    (this.cells.connector_name.displayControl as TextModel).text = $row.entity.connector_name;
    (this.cells.connector_name.editControl as SelectBoxModel).reset($row.entity.connector_name);
    (this.cells.connector_zone.displayControl as TextModel).text = $row.entity.connector_zone;
    (this.cells.connector_zone.editControl as TextBoxModel).reset($row.entity.connector_zone);
    (this.cells.footprint_zone.displayControl as TextModel).text = $row.entity.footprint_zone;
    (this.cells.connector_id.displayControl as TextModel).text = $row.entity.connector_id;
    (this.cells.connector_id.editControl as TextModel).text = $row.entity.connector_id;

  }

  override async refresh() {
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
      await this.on_save_new_row();
      this.isNew = false;
    } else {
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
    }
  }

  //#region private flows
  on_save_new_row(event = null) {
    return this.on_save_new_rowInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$frontendFlows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_save_new_rowInternal(
    $row: ProgrammableLogicController_connector_mappings_gridComponentRowModel,
  $grid: ProgrammableLogicController_connector_mappings_gridComponent, 
    $shell: ProgrammableLogicController_ShellService,
    $datasources: ProgrammableLogicController_DatasourceService,
    $flows: ProgrammableLogicController_FlowService,
    $frontendFlows: ProgrammableLogicController_FrontendFlowService,
    $reports: ProgrammableLogicController_ReportService,
    $settings: SettingsValuesService,
    $operations: ProgrammableLogicController_OperationService,
    $utils: UtilsService,
    $context: ProgrammableLogicController_connector_mappings_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ProgrammableLogicController_LocalizationService,
    $event: any
  ) {
    this.$logger.log('ProgrammableLogicController', 'connector_mappings_grid.on_save_new_row');
  try {
  
  
      let connector_zone = $row.cells.connector_zone.editControl.value
      let footprint_zone = $row.cells.footprint_zone.editControl.displayText
      let connector_id = $row.cells.connector_id.editControl.text
      let connector_name = $row.cells.connector_name.editControl.displayText
      let warehouse_name = $row.cells.warehouse.editControl.displayText
      let warehouse_id = $row.cells.warehouse.editControl.value
  
      if ($utils.isDefinedTrimmed(connector_id)) {
          let updateResult = (await $flows.ProgrammableLogicController.insert_connector_mapping_flow({
              connector_zone: connector_zone,
              footprint_zone: footprint_zone,
              connector_id: connector_id,
              connector_name: connector_name,
              warehouse_name: warehouse_name,
              warehouse_id: warehouse_id 
  
          }));
          if ($utils.isDefined(updateResult.reasons)) {
              throw new Error(updateResult.reasons.join(', '))
          }
          else {
              $grid.refresh();
          }
      }
  
  }
  catch (error) {
      $shell.Utilities.showErrorDetails('Save', 'Error on save.', error);
      throw error; // to prevent displayMode 
  }
  
  }
  on_connector_changed(event = null) {
    return this.on_connector_changedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$frontendFlows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_connector_changedInternal(
    $row: ProgrammableLogicController_connector_mappings_gridComponentRowModel,
  $grid: ProgrammableLogicController_connector_mappings_gridComponent, 
    $shell: ProgrammableLogicController_ShellService,
    $datasources: ProgrammableLogicController_DatasourceService,
    $flows: ProgrammableLogicController_FlowService,
    $frontendFlows: ProgrammableLogicController_FrontendFlowService,
    $reports: ProgrammableLogicController_ReportService,
    $settings: SettingsValuesService,
    $operations: ProgrammableLogicController_OperationService,
    $utils: UtilsService,
    $context: ProgrammableLogicController_connector_mappings_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ProgrammableLogicController_LocalizationService,
    $event: any
  ) {
    this.$logger.log('ProgrammableLogicController', 'connector_mappings_grid.on_connector_changed');
  
  let connector_id = (await $datasources.ProgrammableLogicController.ds_get_connectors_name_dd.getList({connector_ids: [$row.cells.connector_name.editControl.value]})).result[0]
  
  $row.cells.connector_id.editControl.text = connector_id.id
  $row.cells.connector_id.displayControl.text = connector_id.id
  
  
  }
  //#endregion private flows

}


@Component({
  imports: [
    SharedModule,
    forwardRef(() => ProgrammableLogicController_warehouses_dd_singleComponent),
    forwardRef(() => ProgrammableLogicController_connectors_dd_singleComponent),
    forwardRef(() => ProgrammableLogicController_location_zone_dd_singleComponent),
  ],
  selector: 'ProgrammableLogicController-connector_mappings_grid',
  templateUrl: './ProgrammableLogicController.connector_mappings_grid.component.html'
})
export class ProgrammableLogicController_connector_mappings_gridComponent extends BaseComponent implements OnInit, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IProgrammableLogicController_connector_mappings_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;

canEdit: boolean = true;
// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
canAdd: boolean = true; 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['default','fit-content-table']);

  fullTextSearch: string;



  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     warehouse: new GridHeaderModel(new HeaderStyles(null, null), 'warehouse', 'Warehouse', true, false, null, false),       connector_name: new GridHeaderModel(new HeaderStyles(null, null), 'connector_name', 'Connector', true, false, null, false),       connector_zone: new GridHeaderModel(new HeaderStyles(null, null), 'connector_zone', 'Connector zone', true, false, null, false),       footprint_zone: new GridHeaderModel(new HeaderStyles(null, null), 'footprint_zone', 'Footprint zone', true, false, null, false),       connector_id: new GridHeaderModel(new HeaderStyles(null, null), 'connector_id', 'Connector id', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: ProgrammableLogicController_connector_mappings_gridComponentRowModel[] = [];


  topToolbar = {
      delete_button: new ToolModel(new ButtonModel('delete_button', new ButtonStyles(['destructive'], null), false, false, false, 'Delete', 'icon-ic_fluent_delete_20_regular', null)
    , false)
  };

  bottomToolbar = {
    addLine : new ToolModel(new ButtonModel(null, null, false, false, false, 'Add row', 'icon-ic_fluent_add_circle_20_regular')),
  };




  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: ProgrammableLogicController_ShellService,
    private $datasources: ProgrammableLogicController_DatasourceService,
    private $flows: ProgrammableLogicController_FlowService,
    private $frontendFlows: ProgrammableLogicController_FrontendFlowService,
    private $reports: ProgrammableLogicController_ReportService,
    private $localization: ProgrammableLogicController_LocalizationService,
    private $operations: ProgrammableLogicController_OperationService,
    private $logger: CleanupLoggerService,
    private $context: ProgrammableLogicController_connector_mappings_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Connector mapping';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  


  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 25;


    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    const $grid = this;
    const $utils = this.$utils;
    const $inParams: { fullTextSearch?: string, $top?: number, $skip?: number } = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      fullTextSearch:  $grid.fullTextSearch ,
    };
    try {
      const $data = await this.$datasources.ProgrammableLogicController.ds_connector_mappings_grid.getList($inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns($inParams, $data);

      this.entities = $data.result as IProgrammableLogicController_connector_mappings_gridComponentEntity[];
      this.totalCount = $data.totalCount;

      await this.$dataLoaded();
      
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new ProgrammableLogicController_connector_mappings_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$frontendFlows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

  }

  
    async $applyLinkedDatasourcesAndCustomColumns($inParams: any, $outParams: any) {
      const $datasource = { inParams: $inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }

  selectedRows: ProgrammableLogicController_connector_mappings_gridComponentRowModel[] = [];
  hasSelectedRows() {
    return this.selectedRows.length > 0;
  }

  async $selectionChanged(selectedRows: any[]) {
    this.selectedRows = selectedRows;
  }

  async addRow(entity?: IProgrammableLogicController_connector_mappings_gridComponentEntity) {
    const row = new ProgrammableLogicController_connector_mappings_gridComponentRowModel(
      this,
      this.$utils,
      this.$settings,
      this.$shell, 
      this.$datasources,
      this.$flows,
      this.$frontendFlows,
      this.$reports,
      this.$localization,
      this.$operations,
      this.$logger,
      this.$context);
    await row.$initializeNew(entity);
    this.rows.push(row);
    row.setEditMode();
    return row;
  }
  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_delete_clicked(event = null) {
    return this.on_delete_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$frontendFlows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_delete_clickedInternal(
    $grid: ProgrammableLogicController_connector_mappings_gridComponent,
  
    $shell: ProgrammableLogicController_ShellService,
    $datasources: ProgrammableLogicController_DatasourceService,
    $flows: ProgrammableLogicController_FlowService,
    $frontendFlows: ProgrammableLogicController_FrontendFlowService,
    $reports: ProgrammableLogicController_ReportService,
    $settings: SettingsValuesService,
    $operations: ProgrammableLogicController_OperationService,
    $utils: UtilsService,
    $context: ProgrammableLogicController_connector_mappings_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ProgrammableLogicController_LocalizationService,
    $event: any
  ) {
    this.$logger.log('ProgrammableLogicController', 'connector_mappings_grid.on_delete_clicked');
  for(let row of $grid.selectedRows){
      await $flows.ProgrammableLogicController.delete_connector_zone_mappings({connector_id: row.entity.connector_id, connector_zone: row.entity.connector_zone, footprint_zone: row.entity.footprint_zone})
  }
  
  $grid.refresh();
  }
  on_grid_data_load(event = null) {
    return this.on_grid_data_loadInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$frontendFlows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_grid_data_loadInternal(
    $grid: ProgrammableLogicController_connector_mappings_gridComponent,
  
    $shell: ProgrammableLogicController_ShellService,
    $datasources: ProgrammableLogicController_DatasourceService,
    $flows: ProgrammableLogicController_FlowService,
    $frontendFlows: ProgrammableLogicController_FrontendFlowService,
    $reports: ProgrammableLogicController_ReportService,
    $settings: SettingsValuesService,
    $operations: ProgrammableLogicController_OperationService,
    $utils: UtilsService,
    $context: ProgrammableLogicController_connector_mappings_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ProgrammableLogicController_LocalizationService,
    $event: any
  ) {
    this.$logger.log('ProgrammableLogicController', 'connector_mappings_grid.on_grid_data_load');
  $grid.headers.connector_id.hidden = true
  }
  //#endregion private flows


 
  close() {
    this.$finish.emit();
  }
}
